import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-wellbean-forgot-password',
  templateUrl: './wellbean-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './wellbean-forgot-password.component.css',
  ],
})
export class WellbeanForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
